var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckboxChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.44971 22H18.5503C20.8574 22 22 20.8574 22 18.5942V5.40576C22 3.14258 20.8574 2 18.5503 2H5.44971C3.15356 2 2 3.13159 2 5.40576V18.5942C2 20.8684 3.15356 22 5.44971 22ZM10.6133 17.7324C10.2397 17.7324 9.94312 17.5676 9.6355 17.1941L6.47144 13.283C6.30664 13.0742 6.20776 12.8105 6.20776 12.5688C6.20776 12.0525 6.60327 11.657 7.09766 11.657C7.41626 11.657 7.67993 11.7778 7.9436 12.1184L10.5693 15.5132L15.667 7.32837C15.8867 6.98779 16.1724 6.823 16.458 6.823C16.9414 6.823 17.4028 7.1416 17.4028 7.66895C17.4028 7.91064 17.271 8.17432 17.1282 8.39404L11.5361 17.1941C11.3054 17.5566 10.9978 17.7324 10.6133 17.7324Z",
    fill: "#878793"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckboxChecked);
export default __webpack_public_path__ + "static/media/icon-checkbox-checked.17bb3066ac5d67cbf21d814d20862a4c.svg";
export { ForwardRef as ReactComponent };